import { 
  CREATING_EXTERNAL_FORM_REQUEST, CREATING_EXTERNAL_FORM_SUCCEEDED, CREATING_EXTERNAL_FORM_FAILED,
  UPDATING_EXTERNAL_FORM_REQUEST, UPDATING_EXTERNAL_FORM_SUCCEEDED, UPDATING_EXTERNAL_FORM_FAILED,
  DELETING_EXTERNAL_FORM_REQUEST, DELETING_EXTERNAL_FORM_SUCCEEDED, DELETING_EXTERNAL_FORM_FAILED
 } from "constants/actionTypes";

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/1.0`;
const EXTERNAL_FORM_URL = `${apiUrl}/forms/external`;

/*
* Create External Form
*/
export const createExternalForm = createAction(CREATING_EXTERNAL_FORM_REQUEST, (request) => {
  return {
    request: request
  }
})

const createExternalFormSucceeded = createAction(CREATING_EXTERNAL_FORM_SUCCEEDED, (response) => {
  return {
    response: response
  }
})

const createExternalFormFailed = createAction(CREATING_EXTERNAL_FORM_FAILED, (error) => {
  return {
    error: error
  }
})

function* createExternalFormSaga(action) {
  const { request } = action.payload;

  const createExternalFormAPI = () => {
    return axios.post(EXTERNAL_FORM_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createExternalFormAPI);
    if (response) {
      yield put(createExternalFormSucceeded(response));
    }
  } catch (error) {
    yield put(createExternalFormFailed(error));
  }
}

/**
 * Update External form
 */
export const updateExternalForm = createAction(UPDATING_EXTERNAL_FORM_REQUEST, (id, request) => {
  return {
    id: id,
    request: request
  }
})

const updateExternalFormSucceeded = createAction(UPDATING_EXTERNAL_FORM_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const updateExternalFormFailed = createAction(UPDATING_EXTERNAL_FORM_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* updateExternalFormSaga(action) {
  const { id, request } = action.payload;

  let url = buildUrl(EXTERNAL_FORM_URL, {
    path: `/${id}`
  });

  const updateExternalFormAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateExternalFormAPI);
    yield put(updateExternalFormSucceeded(id, response));
  } catch (error) {
    yield put(updateExternalFormFailed(id, error));
  }
}

/**
 * Delete External form
 */
export const deleteExternalForm = createAction(DELETING_EXTERNAL_FORM_REQUEST, (id) => {
  return {
    id: id
  }
})

const deleteExternalFormSucceeded = createAction(DELETING_EXTERNAL_FORM_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const deleteExternalFormFailed = createAction(DELETING_EXTERNAL_FORM_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* deleteExternalFormSaga(action) {
  const { id } = action.payload;

  let url = buildUrl(EXTERNAL_FORM_URL, {
    path: `/${id}`
  });

  const deleteExternalFormAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    const response = yield call(deleteExternalFormAPI);
    yield put(deleteExternalFormSucceeded(id, response));
  } catch (error) {
    yield put(deleteExternalFormFailed(id, error));
  }
}

export default function* externalFormSaga() {
  yield takeEvery(CREATING_EXTERNAL_FORM_REQUEST, createExternalFormSaga);
  yield takeEvery(UPDATING_EXTERNAL_FORM_REQUEST, updateExternalFormSaga);
  yield takeEvery(DELETING_EXTERNAL_FORM_REQUEST, deleteExternalFormSaga);
}